import Swiper from 'swiper';
import 'swiper/css';

export const initProductSlider = (slider, slidesPerView = 1.5, slidesSM = 2.5, slidesMD = 3.5, slidesLG = 4.5) => {

    if(slider.dataset.slidessm) {
        slidesSM = slider.dataset.slidessm;
    }
    if(slider.dataset.slidesmd) {
        slidesMD = slider.dataset.slidesmd;
    }
    if(slider.dataset.slideslg) {
        slidesLG = slider.dataset.slideslg;
    }

    const swiper = new Swiper(slider, {
        slidesPerView: slidesPerView,
        spaceBetween: 16,
        navigation: {
            nextEl: slider.parentElement.querySelector(".js-product-slider-next"),
            prevEl:  slider.parentElement.querySelector(".js-product-slider-prev"),
        },
        pagination: {
            el:  slider.parentElement.querySelector(".js-product-slider-pagination"),
            clickable: true,
        },
        breakpoints: {
            640: {
                slidesPerView: slidesSM,
            },
            768: {
                slidesPerView: slidesMD,
            },
            1024: {
                slidesPerView: slidesLG,
            },
        },
    });
};

[...document.querySelectorAll('.js-product-slider')].map(initProductSlider);
